import React from "react";
import classes from "./Loading.module.css";

const Loading = (props) => {
  //return <div className={classes.loading}>{props.children}</div>;
  return <div className={classes.loading}>{props.children}</div>;
};

export default Loading;
